// Recoilのatomをインポート
import { atom } from 'recoil';

/**
 * ユーザーのグローバル状態を管理するためのRecoilのatom
 * 
 * `userState`は、以下のユーザー情報を保持します:
 * - email: ユーザーのメールアドレス
 * - userId: ユーザーのID
 * - userType: ユーザーの種類（例: 管理者、一般ユーザーなど）
 * - token: 認証トークン
 * - companyName: ユーザーが所属する会社名
 */
const userState = atom({
  // 他のatomやセレクターと区別するための一意のキー
  key: 'userState',

  // 状態の初期値を定義
  default: {
    // sessionStorageから値を取得（ログイン情報がセッションに保存されている場合）
    // データが存在しない場合は空文字列や0を代入
    email: sessionStorage.getItem('email') ?? '', // ユーザーのメールアドレス
    userId: Number(sessionStorage.getItem('userId')) ?? 0, // ユーザーID
    userName: sessionStorage.getItem('userName') ?? '', // ユーザーname
    userType: Number(sessionStorage.getItem('userType')) ?? 0, // ユーザーの種類
    token: sessionStorage.getItem('token') ?? '', // 認証トークン
    companyName: sessionStorage.getItem('companyName') ?? '' // ユーザーが所属する会社名
  }
});

// userStateを他のファイルで利用できるようにエクスポート
export default userState;
